export default __webpack_public_path__ + "static/logo-455aa0fecae037128111b226627a7160.png";